// stores/subscriptionPlanStore.js
import { create } from "zustand";
import axiosToken from "../api/axiosClient";

export const useSubscriptionPlanStore = create((set, get) => ({
  subscriptions: [],
  currentSubscription: null,
  loading: false,
  error: null,

  // Récupérer tous les abonnements
  fetchSubscriptions: async () => {
    set({ loading: true, error: null });
    try {
      const response = await axiosToken.get(`/subscription-plans`);
      set({
        subscriptions: response.data.data,
        loading: false,
      });
    } catch (error) {
      set({
        error:
          error.response?.data?.message ||
          "Erreur lors de la récupération des abonnements",
        loading: false,
      });
    }
  },

  fetchSubscriptionsActif: async () => {
    set({ loading: true, error: null });
    try {
      const response = await axiosToken.get(
        `/subscription-plans?isActive=true`,
      );
      set({
        subscriptions: response.data.data,
        loading: false,
      });
    } catch (error) {
      set({
        error:
          error.response?.data?.message ||
          "Erreur lors de la récupération des abonnements",
        loading: false,
      });
    }
  },

  // Créer un nouvel abonnement
  createSubscription: async (subscriptionData) => {
    set({ loading: true, error: null });
    try {
      const response = await axiosToken.post(
        `/subscription-plans`,
        subscriptionData,
      );
      const newSubscription = response.data.data;

      set((state) => ({
        subscriptions: [...state.subscriptions, newSubscription],
        loading: false,
      }));

      return newSubscription;
    } catch (error) {
      set({
        error:
          error.response?.data?.message ||
          "Erreur lors de la création de l'abonnement",
        loading: false,
      });
      throw error;
    }
  },

  // Mettre à jour un abonnement
  updateSubscription: async (id, subscriptionData) => {
    set({ loading: true, error: null });
    try {
      const response = await axiosToken.put(
        `/subscription-plans/${id}`,
        subscriptionData,
      );
      const updatedSubscription = response.data.data;

      set((state) => ({
        subscriptions: state.subscriptions.map((sub) =>
          sub.id === id ? updatedSubscription : sub,
        ),
        loading: false,
      }));

      return updatedSubscription;
    } catch (error) {
      set({
        error:
          error.response?.data?.message ||
          "Erreur lors de la mise à jour de l'abonnement",
        loading: false,
      });
      throw error;
    }
  },

  // Supprimer un abonnement
  deleteSubscription: async (id) => {
    set({ loading: true, error: null });
    try {
      await axiosToken.delete(`/subscription-plans/${id}`);

      set((state) => ({
        subscriptions: state.subscriptions.filter((sub) => sub.id !== id),
        loading: false,
      }));
    } catch (error) {
      set({
        error:
          error.response?.data?.message ||
          "Erreur lors de la suppression de l'abonnement",
        loading: false,
      });
      throw error;
    }
  },

  // Récupérer un abonnement par ID
  fetchSubscriptionById: async (id) => {
    set({ loading: true, error: null });
    try {
      const response = await axiosToken.get(`/subscription-plans/${id}`);
      set({
        currentSubscription: response.data.data,
        loading: false,
      });
    } catch (error) {
      set({
        error:
          error.response?.data?.message ||
          "Erreur lors de la récupération de l'abonnement",
        loading: false,
      });
      throw error;
    }
  },

  // Activer/Désactiver un abonnement
  toggleSubscriptionStatus: async (id, isActive) => {
    set({ loading: true, error: null });
    try {
      const response = await axiosToken.patch(
        `/subscription-plans/${id}/change-status`,
        { isActive },
      );
      const updatedSubscription = response.data.data;

      // console.log({ updatedSubscription })
      // console.log("currentSubscription: ", get().currentSubscription);
      // console.log("New list: ", { ...get().currentSubscription, ...updatedSubscription });

      set((state) => ({
        subscriptions: state.subscriptions.map((sub) =>
          sub.id === id ? { ...sub, ...updatedSubscription } : sub,
        ),
        currentSubscription:
          state.currentSubscription && state.currentSubscription.id === id
            ? { ...state.currentSubscription, ...updatedSubscription }
            : state.currentSubscription,
        loading: false,
      }));

      return updatedSubscription;
    } catch (error) {
      set({
        error:
          error.response?.data?.message ||
          "Erreur lors du changement de statut",
        loading: false,
      });
      throw error;
    }
  },

  // Réinitialiser les erreurs
  clearError: () => set({ error: null }),

  // Réinitialiser l'abonnement courant
  clearCurrentSubscription: () => set({ currentSubscription: null }),
}));
